/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ETransportShipmentOrganizerNotificationVo } from './e-transport-shipment-organizer-notification-vo';
import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportShipmentOrganizerNotificationListVo extends JSONable {
  list: ETransportShipmentOrganizerNotificationVo[] = [];
  error: string | null = null;
}
